import { useMemo } from 'react'

import { RentalTagsInner } from './RentalTagsInner'
import { RentalTagsProvider } from './RentalTagsProvider'
import type { RentalTagsRowProps } from './RentalTagsRow.types'
import type { Tag, TagColor } from './tagging.types'

export const RentalTagsRow = (props: RentalTagsRowProps) => {
  const { readOnly = false, rental, refetch } = props
  const rentalId = rental.id

  const rentalTags = useMemo<Tag[]>(
    () =>
      (rental.tags ?? []).map(t => ({
        color: t.color as TagColor,
        id: t.id,
        inherited: t.inherited,
        inheritedFrom: t.inheritedFrom ?? undefined,
        name: t.name,
      })),
    [rental.tags],
  )

  return (
    <RentalTagsProvider
      refetch={refetch}
      rentalId={rentalId}
      rentalTags={rentalTags}
    >
      <RentalTagsInner
        readOnly={readOnly}
        rentalId={rentalId}
        tags={rentalTags}
      />
    </RentalTagsProvider>
  )
}
